import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import type { SnapshotManifest } from '@cli-types/core-engine/snapshots.js'
import type { ReconstructionResult } from '@cli-types/next-adapter/snapshots.js'
import { hashContent } from '@cli-utils/files.js'
import { hasSnapshotFiles } from '@core-engine/snapshots/store/has-snapshot-files.js'
import { manifestFilesByPath } from '@core-engine/snapshots/store/manifest-files-by-path.js'
import { readSnapshotFiles } from '@core-engine/snapshots/store/read-snapshot-files.js'
import { writeSnapshotFiles } from '@core-engine/snapshots/store/write-snapshot-files.js'
import { renderManifestFiles } from './render-manifest-files.js'

export function reconstructSnapshotFiles(
  cwd: string,
  config: ResolvedBetterstartConfig,
  manifest: SnapshotManifest
): ReconstructionResult {
  const trackedPaths = manifest.files.map((file) => file.path).sort()

  if (hasSnapshotFiles(cwd, manifest.schemaName)) {
    return {
      files: readSnapshotFiles(cwd, manifest.schemaName, manifest),
      mismatchedPaths: [],
      trackedPaths
    }
  }

  const renderedFiles = renderManifestFiles(cwd, config, manifest).filter(
    (file) => !manifest.skipped.includes(file.path)
  )
  const manifestFiles = manifestFilesByPath(manifest)
  const validFiles: GeneratedFile[] = []
  const mismatchedPaths: string[] = []

  for (const file of renderedFiles) {
    const manifestFile = manifestFiles.get(file.path)
    if (!manifestFile || manifestFile.hash !== hashContent(file.content)) {
      mismatchedPaths.push(file.path)
      continue
    }
    validFiles.push(file)
  }

  if (validFiles.length > 0) {
    writeSnapshotFiles(cwd, manifest.schemaName, validFiles)
  }

  return {
    files: validFiles,
    mismatchedPaths,
    trackedPaths
  }
}
